import React from "react";
import { Timeline } from "primereact/timeline";
import { Card } from "primereact/card";
import "animate.css";
import AOS from "aos";
import "aos/dist/aos.css"; // You can also use <link> for styles
// import './TimelineDemo.css';
import "primeicons/primeicons.css";

AOS.init();

export default function TemplateDemo(dark) {
  const events = [
    {
      status: "Fullstack Devloper",
      Compane: "SIMBO.AI",
      date: "JAN 2025 - Present 2025",
      icon: "pi pi-chevron-circle-right",
      Tech: ["AngularJs", "PHP", "SHELL Script", "Python", "EHR", "Linux Commands"],
    },
    {
      status: "Fullstack Engineer Intern",
      Compane: "Microtech I.T Systems",
      date: "JAN 2024 - DEC 2024",
      icon: "pi pi-chevron-circle-left",
      Tech: [
        "Nextjs",
        "NodeJs",
        "ExpressJs",
        "NodeMailer",
        "Jira",
        "SwaggerAPI",
        "Prisma",
        "Postgress",
        "MongoDB",
        "CRUD",
        "Docker",
        "SQL",
      ],
    },
    {
      status: "Python Developer Intern",
      Compane: "Cilans Systems",
      date: "MAR 2023 - AUG 2023",
      icon: "pi pi-chevron-circle-left",
      Tech: ["Python", "Tkinter","BlueIO","Nodejs","ReacJs"],
    },
    {
      status: "Gujarat Technological University",
      Compane: "Information Comunication Technology",
      date: "2019 - 2023",
      icon: "pi pi-chevron-circle-right",
      Tech: [],
    },
  ];

  const customizedMarker = (item) => {
    return (
      <span
        className="flex w-2rem h-2rem align-items-center justify-content-center text-white border-circle z-1 shadow-1"
        style={{ backgroundColor: item.color }}
      >
        <i className={item.icon}></i>
      </span>
    );
  };

  const customizedContent = (item) => {
    return (
      <>
        <Card
          title={item.status}
          subTitle={item.Compane}
          header={item.desc}
          data-aos="fade-in"
          data-aos-duration="1000"
          style={{
            width: "100%",
            height: "100%",
            borderRadius: "0.5rem",
            boxShadow:
              "0 2px 1px -1px rgb(0 0 0 / 20%), 0 1px 1px 0 rgb(0 0 0 / 14%), 0 1px 3px 0 rgb(0 0 0 / 12%)",
            backgroundColor: "blue",
            textAlign: "center",
            color: "white",
          }}
          className="c_1"
        >
          <h6>{item.date}</h6>
          <ul
            className="sizes-box text-white"
            style={{
              justifyContent: "start",
            }}
          >
            {item.Tech.map((tech) => (
              <li
                className="p-2 mt-2"
                style={{
                  boxShadow: "none",
                  color: "darkblue",
                  padding: "2rem",
                  backgroundColor: "white",
                  borderRadius: "0.5rem",
                }}
              >
                {tech}
              </li>
            ))}
          </ul>
        </Card>
      </>
    );
  };

  return (
    <div className="card w-100">
      <h1 className="bold p-3 text-white">Experience And Education</h1>
      <Timeline
        value={events}
        align="alternate"
        className="customized-timeline"
        marker={customizedMarker}
        content={customizedContent}
      />
    </div>
  );
}
